export interface Language {
  code: string;
  name: string;
  localName: string;
  flag: string;
  speechCode: string;
}

export const languages: Language[] = [
  { code: "es", name: "Español", localName: "Español", flag: "🇪🇸", speechCode: "es-ES" },
  { code: "en", name: "Inglés", localName: "English", flag: "🇺🇸", speechCode: "en-US" },
  { code: "pt", name: "Portugués", localName: "Português", flag: "🇧🇷", speechCode: "pt-BR" },
  { code: "fr", name: "Francés", localName: "Français", flag: "🇫🇷", speechCode: "fr-FR" },
  { code: "de", name: "Alemán", localName: "Deutsch", flag: "🇩🇪", speechCode: "de-DE" },
  { code: "it", name: "Italiano", localName: "Italiano", flag: "🇮🇹", speechCode: "it-IT" },
  { code: "ja", name: "Japonés", localName: "日本語", flag: "🇯🇵", speechCode: "ja-JP" },
  { code: "ko", name: "Coreano", localName: "한국어", flag: "🇰🇷", speechCode: "ko-KR" },
  { code: "zh-CN", name: "Chino", localName: "中文", flag: "🇨🇳", speechCode: "zh-CN" },
  { code: "ar", name: "Árabe", localName: "العربية", flag: "🇸🇦", speechCode: "ar-SA" },
  { code: "ru", name: "Ruso", localName: "Русский", flag: "🇷🇺", speechCode: "ru-RU" },
  { code: "tr", name: "Turco", localName: "Türkçe", flag: "🇹🇷", speechCode: "tr-TR" },
  { code: "nl", name: "Neerlandés", localName: "Nederlands", flag: "🇳🇱", speechCode: "nl-NL" },
  { code: "pl", name: "Polaco", localName: "Polski", flag: "🇵🇱", speechCode: "pl-PL" },
  { code: "uk", name: "Ucraniano", localName: "Українська", flag: "🇺🇦", speechCode: "uk-UA" },
  { code: "hi", name: "Hindi", localName: "हिन्दी", flag: "🇮🇳", speechCode: "hi-IN" },
  { code: "id", name: "Indonesio", localName: "Bahasa Indonesia", flag: "🇮🇩", speechCode: "id-ID" },
  { code: "th", name: "Tailandés", localName: "ไทย", flag: "🇹🇭", speechCode: "th-TH" },
  { code: "vi", name: "Vietnamita", localName: "Tiếng Việt", flag: "🇻🇳", speechCode: "vi-VN" },
  { code: "he", name: "Hebreo", localName: "עברית", flag: "🇮🇱", speechCode: "he-IL" },
  { code: "sv", name: "Sueco", localName: "Svenska", flag: "🇸🇪", speechCode: "sv-SE" },
  { code: "da", name: "Danés", localName: "Dansk", flag: "🇩🇰", speechCode: "da-DK" },
  { code: "no", name: "Noruego", localName: "Norsk", flag: "🇳🇴", speechCode: "nb-NO" },
  { code: "fi", name: "Finés", localName: "Suomi", flag: "🇫🇮", speechCode: "fi-FI" },
  { code: "el", name: "Griego", localName: "Ελληνικά", flag: "🇬🇷", speechCode: "el-GR" },
  { code: "cs", name: "Checo", localName: "Čeština", flag: "🇨🇿", speechCode: "cs-CZ" },
  { code: "ro", name: "Rumano", localName: "Română", flag: "🇷🇴", speechCode: "ro-RO" },
  { code: "hu", name: "Húngaro", localName: "Magyar", flag: "🇭🇺", speechCode: "hu-HU" },
  { code: "ca", name: "Catalán", localName: "Català", flag: "🏴", speechCode: "ca-ES" },
];

export const languageByCode = (code: string) => languages.find((language) => language.code === code) ?? languages[0];
